import React, {useEffect} from 'react'
import blueRobot from '../../../assets/images/bluerobot.png'

const PublicChat = ({avatar }) => {

    return <livelike-chat messagemenus showavatar avatarurl={avatar || blueRobot} roomid="7909c027-04ae-4ecd-bf9c-7f553bb1dc21">
        <div slot="message-list-empty">
            <h1 style={{ color: '#fff'}}>
                Noch keine Nachrichten.
            </h1>
        </div>
    </livelike-chat>
}



export default PublicChat;